/* ⚛ REACT */
import React, {useState} from "react";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 🎨 STYLES */
import { Container, ContainerIcon, SideBarIcon, SubItensContainer, TextItem, ContainerSvg } from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../../../util/validate";

import { AnimatePresence } from "framer-motion";

const SideBarItem = (props) => {
    const Icon = isValidaProp(props.Icon) ? props.Icon : null;
    const [buttonsVisibility, setButtonsVisibility] = useState(false);
    const aling = useSelector(state => state.MenuReducer.MenuAling);
    const childs = React.Children.toArray(props.children);
    
    const changePage = (e)=>{
        e.preventDefault()
        if(childs.length> 1){return}
        if(props.function){props.function()}
        
    }

    return(
        <Container 
            $active={props.function !== undefined || childs.length > 0 ? true : false}
            onMouseEnter={()=> {
                childs.length>0 ? setButtonsVisibility(true) : setButtonsVisibility(false);
            }}
            onMouseLeave={()=> {
                setButtonsVisibility(false);
            }}>
            <ContainerIcon $select={props.select} $aling={aling} $function={props.function !== undefined || childs.length > 0 ? true : false} 
                onClick={(e)=> changePage(e)} href={childs.length < 1 ? props.page : null} $show={buttonsVisibility}>
                <ContainerSvg>
                    <SideBarIcon src={Icon} fill={props.function !== undefined || childs.length > 0 ? '#F2F2F2' : '#A3A3A3'}/>
                </ContainerSvg>
                    {(props.visibility && (childs.length<1 || !buttonsVisibility) ) && <TextItem $aling={aling} 
                    $function={props.function !== undefined || childs.length > 0 ? true : false} > {props.Text} </TextItem>}
                    
                <AnimatePresence>
                    {buttonsVisibility && (
                        <SubItensContainer
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.25, ease: "easeInOut" }}
                        >
                            {childs.map(child => child)}
                        </SubItensContainer>
                    )}
                </AnimatePresence>
            </ContainerIcon>
            
        </Container>
    )
}

export default SideBarItem;